import { apartmentsApi } from '../api/apartmentsApi';
import { parkingManagementApi } from '../api/parkingManagementApi';

const PARKING_FEE_CODES = new Set([
  'XE001',
  'XE002',
  'XE003',
  'XE004',
  'XE005',
  'XE006',
  'XE007',
  'DV002A',
  'DV002B',
  'DV002C',
  'DV002D',
]);

export function isParkingFeeCode(feeCode?: string | null): boolean {
  if (!feeCode) return false;
  const normalized = feeCode.trim().toUpperCase();
  if (PARKING_FEE_CODES.has(normalized)) return true;
  return /^XE\d{3}$/.test(normalized);
}

export const MANUAL_PARKING_FIXED_INVOICE_BLOCKED_MESSAGE =
  'Phí gửi xe theo xe tháng — dùng Tạo phí (Quản lý phí / Xe tháng), không thêm hóa đơn thủ công.';

/** Block Thêm hóa đơn thủ công when căn already has xe tháng for this parking SKU. */
export async function assertCanAddManualFixedParkingInvoice(params: {
  apartmentId: string;
  buildingId: string;
  feeCategoryId: string;
  feeCode?: string | null;
  apartmentCode?: string | null;
}): Promise<void> {
  if (!isParkingFeeCode(params.feeCode)) return;

  const cardTypes = await parkingManagementApi.listVehicleCardTypes(params.buildingId);
  const cardTypeIds = new Set(
    cardTypes
      .filter((type) => type.feeCategoryId === params.feeCategoryId && type.isActive !== false)
      .map((type) => type.id),
  );
  if (cardTypeIds.size === 0) return;

  const apartmentCode =
    params.apartmentCode?.trim() ||
    (await apartmentsApi.getApartmentById(params.apartmentId)).code;
  const { data: vehicles } = await parkingManagementApi.listMonthlyVehicles({
    buildingId: params.buildingId,
    search: apartmentCode,
    limit: 100,
  });

  const hasVehicle = vehicles.some(
    (vehicle) =>
      vehicle.apartmentId === params.apartmentId &&
      vehicle.status !== 'DELETED' &&
      cardTypeIds.has(vehicle.vehicleCardTypeId),
  );

  if (hasVehicle) {
    throw new Error(MANUAL_PARKING_FIXED_INVOICE_BLOCKED_MESSAGE);
  }
}
